module.exports = __webpack_public_path__ + "img/repository.9808d99e.svg";